import React, { useEffect, useRef, useState } from 'react'

import TextField from 'karrierhub-ui/dist/common/src/components/Input/Text'

import VisibleIcon from 'karrierhub-ui/dist/common/src/svg/VisibleIcon'
import NoVisibleIcon from 'karrierhub-ui/dist/common/src/svg/NoVisibleIcon'

const VisibleIconState = React.forwardRef(({ active, effect, ...props }, ref) => {

    const [_active, setActive] = useState(active || false)

    useEffect(() => {
        if (effect) {
            effect({
                actions: {
                    setActive: async (value) => {
                        if (value !== _active) {
                            await setActive(value)
                        }
                    }
                }
            })
        }
        return () => {
            if (effect) {
                effect({
                    actions: {
                        setActive: async () => null
                    }
                })
            }
        }
    })

    return _active ? <VisibleIcon {...props} ref={ref} /> : <NoVisibleIcon {...props} ref={ref} />
})

export default function(p) {

    const {
        type,
        autoComplete,
        multiline,
        minRows,
        maxRows,
        placeholder,
        onChange,
        onBlur,
        id,
        HelperTextComponent,
        InputProps = {},
        ...props
    } = p

    const inputRef = useRef()
    const iconRef = useRef()
    const iconEffect = useRef()

    return <TextField
        ContainerProps={{
            name: id
        }}
        {...props}
        InputProps={{
            ...InputProps,
            ref: inputRef,
            ...!onBlur ? { onBlur: onChange } : { onBlur, onChange },
            id,
            type,
            autoComplete,
            placeholder,
            ...multiline ? {
                InputComponent: InputProps.InputComponent || 'textarea',
                minRows,
                maxRows
            } : {}
        }}
        {...HelperTextComponent ? {
            HelperTextComponent
        } : {}}
        {
            ...type === 'password' ? {
                endIcon: <VisibleIconState ref={iconRef} effect={({ actions }) => iconEffect.actions = actions}
                                           disabled={!(props.value)} />,
                onClick: (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (inputRef.current) {
                        inputRef.current.setAttribute('type', inputRef.current.getAttribute('type') === 'password' ? 'text' : 'password')
                        iconEffect.actions?.setActive(inputRef.current.getAttribute('type') === 'text')
                    }
                }
            } : {}
        }
    />
}
